export const EVENTS = {
  switchTown: 'choose-town:switch',
}
